import { render } from "./ai-popup.vue?vue&type=template&id=155031af&scoped=true"
import script from "./ai-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-popup.vue?vue&type=script&setup=true&lang=js"

import "./ai-popup.vue?vue&type=style&index=0&id=155031af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155031af"],['__file',"src/components/ai-popup/ai-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "155031af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('155031af', __exports__)) {
    api.reload('155031af', __exports__)
  }
  
  module.hot.accept("./ai-popup.vue?vue&type=template&id=155031af&scoped=true", () => {
    api.rerender('155031af', render)
  })

}


export default __exports__